import React, {useEffect, useState} from "react";
import {Box, Button, Grid, Typography, useMediaQuery} from "@mui/material";
import Checkbox from "../../../components/shared/checkbox/Checkbox"; // Assuming a custom Checkbox component
import {useTranslation} from "react-i18next";

export default function MultiSelectQuestion({
                                                data,
                                                addQuestion,
                                                deleteQuestionsAfterIndex,
                                                goToNextQuestion,
                                                isVisible,
                                                addToUpdateQuestions,
                                                deleteFromQuestionToUpdate,
                                            }) {
    const {t} = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");

    // State to manage checked choices and error
    const [selectedChoices, setSelectedChoices] = useState(data.currentValue || []);
    const [error, setError] = useState(false);
    const language = localStorage.getItem("i18nextLng");

    // Initialize `selectedChoices` from `currentValue` on mount
    useEffect(() => {
        if (data.currentValue) {
            setSelectedChoices(data.currentValue);
        }
    }, [data.currentValue]);

    // Toggles a choice being selected
    const handleSelection = (choice) => {
        deleteQuestionsAfterIndex(data);
        deleteFromQuestionToUpdate(data);
        if (selectedChoices.includes(choice)) {
            // Deselect if already selected
            setSelectedChoices(selectedChoices.filter((item) => item !== choice));
        } else {
            // Add to selection
            setSelectedChoices([...selectedChoices, choice]);
        }
        setError(false); // Clear error when a choice is selected
    };

    // Handles the "Next" button logic
    const handleNextClick = () => {
        if (data && selectedChoices && selectedChoices !== data.currentValue) {
            addToUpdateQuestions(data, selectedChoices);
        }

        if (data?.key === "WebApp_Architectures_F") {
            if (selectedChoices.includes("CMS")) {
                if (selectedChoices.length > 1) {

                    data.question_object_other.question_object = data.question_object_default;
                    data.question_object_cms.question_object = data.question_object_other;
                    addQuestion(data.question_object_cms);

                } else {

                    data.question_object_cms.question_object = data.question_object_default;
                    addQuestion(data.question_object_cms);

                }
            } else {
                data.question_object_other.question_object = data.question_object_default;
                addQuestion(data.question_object_other);
            }
        } else {
            if (data?.question_object) {
                addQuestion(data?.question_object);
            } else {
                goToNextQuestion();
            }
        }
    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    return (
        <Box
            style={{
                padding: "20px",
                width: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            {/* Question */}
            <Typography variant="subtitle1" sx={{mb: 2}}>
                {language === "fr" ? data?.question_fr : data.question}
            </Typography>

            {/* Checkbox Options */}
            <Grid container spacing={2} m={0} alignItems="center">
                {data.choices.map((choice, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Checkbox
                            title={t(choice)} // Translate the choice value
                            checked={selectedChoices.includes(choice)}
                            value={choice}
                            nextQuestionHandler={() => handleSelection(choice)}
                        />
                    </Grid>
                ))}
            </Grid>

            {/* Error Message */}
            {error && (
                <Typography color="error" sx={{mt: 1}}>
                    {t("This field is required.")}
                </Typography>
            )}


            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={selectedChoices.length === 0} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>
        </Box>
    );
}
